import {FilterRange} from 'modules/decisionsNext/api/types';

export const enum ConfidenceScore {
  VERY_HIGH = 'VERY_HIGH',
  HIGH = 'HIGH',
  MODERATE = 'MODERATE',
  NO_SCORE = 'NO_SCORE',
}

export const confidenceScoreOptions = [
  {
    label: 'Very High (99%-90%)',
    value: ConfidenceScore.VERY_HIGH,
  },
  {
    label: 'High (89%-80%)',
    value: ConfidenceScore.HIGH,
  },
  {
    label: 'Moderate (<80%)',
    value: ConfidenceScore.MODERATE,
  },
  {
    label: 'No Score',
    value: ConfidenceScore.NO_SCORE,
  },
];

export const confidenceScoreFilterRangeMap: Record<ConfidenceScore, FilterRange> = {
  [ConfidenceScore.VERY_HIGH]: {
    from: 90,
    to: 100,
  },
  [ConfidenceScore.HIGH]: {
    from: 80,
    to: 90,
  },
  [ConfidenceScore.MODERATE]: {
    to: 80,
  },
  [ConfidenceScore.NO_SCORE]: {
    notExists: true,
  },
};

export const filterRangeToConfidenceScore = (range: FilterRange): ConfidenceScore => {
  if (range.notExists) {
    return ConfidenceScore.NO_SCORE;
  }

  if (range.to === 80) {
    return ConfidenceScore.MODERATE;
  }

  if (range.to === 90) {
    return ConfidenceScore.HIGH;
  }

  return ConfidenceScore.VERY_HIGH;
};

export const filterRangeToConfidenceScoreLabel = (range: FilterRange): string => {
  return confidenceScoreOptions.find(option => option.value === filterRangeToConfidenceScore(range))?.label || '';
};
